var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',[_c('event-navbar',{attrs:{"title":"Meetings"}}),_c('meeting-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }